import React, { useEffect, useState } from "react";
import useApi from "../../../Utilities/useAPI";
import { useQuantityContext } from "../../../QuantityContext";
// import "bootstrap/dist/css/bootstrap.min.css";
import DefaultProfileBg from "../../../../Assets/img/card/profilebg.png";
import UpcomingEvents from "../../MyProfileDetails/SideFeedComponents/UpcomingEvents";
import RecommendedCourses from '../.././MyProfileDetails/SideFeedComponents/RecommCourses';
import sampleAd from '../../../../Assets/img/sample-ad.jpg';
import { Box } from "@material-ui/core";
import { useParams } from "react-router-dom";

// "../../Assets/img/card/profilebg.png";
const FamilyDashboard = () => {


    // const { groupId } = useQuantityContext();
   const pathArray = window.location.pathname.split('/');
    const groupId = pathArray[pathArray.length - 1];
    
    console.log("Extracted Group ID:", groupId);
    const [familyData, setFamilyData] = useState({});
    const { callApiFunction } = useApi();
    const handleFamilyData = async () => {
        try {
            const payload = { id: groupId };
            const response = await callApiFunction('getGroupCardDetails', payload);

            setFamilyData(response?.data);

            console.log("responseresponse", response, "setFamilyData", familyData);
        } catch (error) {
            console.log("API ERROR", error);
        }
    }

    // useEffect(() => {
    //     handleFamilyData();
    // }, []);
     useEffect(() => {
        if (groupId) {
            handleFamilyData();
        }
    }, [groupId]); 

    return (
        <div className="px-5 py-4 d-flex flex-row gap-3" style={{ backgroundColor: "#f4f7fe" }}>
            <div className="bg-white text-white d-flex flex-column align-items-center rounded">
                <div style={{ maxWidth: "1500px", minWidth: "800px" }}>
                    {/* Header Section */}
                    <div className="d-flex flex-column align-items-center pb-4 " style={{ border: "2px solid #0000001f", borderTopLeftRadius: "6px", borderTopRightRadius: "6px" }}>

                        <div>
                            <h1 className="h4 text-dark fw-bold pt-3">{familyData?.group_info?.group_name}</h1>
                            <p className="text-dark small text-center">
                                {familyData?.group_info?.group_desc}
                            </p>
                        </div>
                        <img
                            src={familyData?.group_info?.group_image || DefaultProfileBg}
                            alt="Family Avatar"
                            className="rounded-circle"
                            width="140"
                            height="140"
                        // style={{ border: '1px solid #0044c6' }}
                        />

                    </div>

                    {/* Member Stats */}
                    <div className="text-center d-flex flex-row justify-content-between py-4" style={{ border: "2px solid #0000001f", borderBottomLeftRadius: "6px", borderBottomRightRadius: "6px", paddingLeft: "150px", paddingRight: "150px" }}>
                        {/* <div className="col-md-3"> */}
                        <div>

                            <p className="fs-5 text-secondary small fw-bold">Total Members</p>
                            <p className="text-dark fw-semibold" style={{ fontSize: "32px" }}>{familyData?.members?.length || 0}</p>
                        </div>
                        {/* </div> */}
                        {/* <div className="col-md-3"> */}
                        <div>

                            <p className="fs-5 text-secondary small fw-bold">Active</p>
                            <p className="fw-semibold text-success" style={{ fontSize: "32px" }}>{familyData?.members?.length || 0}</p>
                        </div>
                        {/* </div> */}
                        {/* <div className="col-md-4"> */}
                        <div>

                            <p className="fs-5 text-secondary small fw-bold">Inactive</p>
                            <p className="fw-semibold text-danger" style={{ fontSize: "32px" }}>0</p>
                        </div>
                        {/* </div> */}
                    </div>


                    {/* Blood Groups */}
                    {/* <div className="d-flex flex-row justify-content-between align-items-start flex-wrap gap-4"> */}

                    {/* Blood Groups */}
                    <div className="bg-white p-3 mt-4 rounded" style={{ flex: "1", border: "2px solid #0000001f" }}>
                        <h2 className="h5 fw-bold ms-2" style={{ color: "#0044c6" }}>Blood Groups</h2>
                        <ul className="list-group" style={{ maxHeight: "200px", overflowY: "auto", scrollbarWidth: "none" }}>
                            {familyData?.members?.map((name, index) => (
                                <li key={index} className="mx-3 p-2 list-group-item d-flex justify-content-between align-items-center bg-white text-dark border-0">
                                    <div className="d-flex flex-row justify-content-center align-items-center gap-4">
                                        <img
                                            src={name?.userDetails?.profile_url || DefaultProfileBg}
                                            alt="Family Avatar"
                                            className="rounded-circle"
                                            width="65"
                                            height="65"
                                        // style={{ border: "1px solid #0044C6" }}
                                        />
                                        <p className="text-align-center mb-0 fw-bold"> {name?.userDetails?.first_name}</p>
                                    </div>
                                    <span className="p-2 badge" style={{ background: "#1976d2" }}>{name?.userDetails?.blood_group || name?.userDetails?.healthInfo?.blood_group}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Events & Reminders */}
                    <div className="bg-white my-2 mt-4 rounded" style={{ border: "2px solid #0000001f" }}>
                        <h2 className="h5 fw-bold ps-3 pt-3" style={{ color: "#0044C6" }}>Events & Reminders</h2>
                        <div className="list-group" style={{ maxHeight: "200px", overflowY: "auto", scrollbarWidth: "thin" }}>

                            <p className="text-dark small text-center fw-bold">
                                {/* {familyData?.group_info?.group_desc}
                                 */}No events available
                            </p>
                        </div>
                    </div>

                    {/* Health Info */}
                    <div className="bg-white p-3 mt-4 rounded " style={{ flex: "1", border: "2px solid #0000001f" }}>
                        <h2 className="h5 fw-bold" style={{ color: "#0044c6" }}>Health Info</h2>
                        <div className="d-flex flex-column align-items-start gap-3 px-3" style={{ maxHeight: "200px", overflowY: "auto", scrollbarWidth: "none" }}>
                            {familyData?.members?.map((member, index) => (
                                <div key={index} className="d-flex flex-row align-items-start gap-2 rounded ps-4 pt-3" style={{ background: "#1976d2", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px", width: "700px" }}>
                                    <img
                                        src={member?.userDetails?.profile_url || DefaultProfileBg}
                                        alt="Profile"
                                        className="rounded-circle text-center"
                                        width="65"
                                        height="65"
                                    // style={{ border: "1px solid #0044c6" }}
                                    />
                                    <div>
                                        <p className="fw-bold mb-1 text-white">
                                            {member?.userDetails?.first_name} {member?.userDetails?.last_name}
                                        </p>
                                        <p className="text-white small mb-1">
                                            {member?.relationship} | Condition:{" "}
                                            {member?.userDetails?.healthInfo?.medical_condition?.length > 0
                                                ? JSON.parse(member?.userDetails?.healthInfo?.medical_condition).join(", ")
                                                : "No known conditions"}
                                        </p>
                                        <p className="text-white small">
                                            Allergies:{" "}
                                            {member?.userDetails?.healthInfo?.allergies?.length > 0
                                                ? JSON.parse(member?.userDetails?.healthInfo?.allergies).join(", ")
                                                : "No known allergies"}
                                        </p>
                                        <p className="text-white small">
                                            Medical History:{" "}
                                            {member?.userDetails?.healthInfo?.medical_history?.length > 0
                                                ? JSON.parse(member?.userDetails?.healthInfo?.medical_history).join(", ")
                                                : "No medical history"}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* </div> */}





                </div>
            </div>
            <div>
                <UpcomingEvents />
                <RecommendedCourses />
                {/* <SocialNetwork activeProfile={activeProfile} socialLinks={cardSocials} /> */}

                <Box className='my-2'>
                    <div className='w-100'>
                        <img className='w-100' src={sampleAd} alt='Ad 1' />
                    </div>
                </Box>

            </div>
        </div >

    );
};

export default FamilyDashboard;
